export default __webpack_public_path__ + "static/media/cz.4b151ea8.svg";